import { createContext, useContext, useState } from 'react'

const ArticulosTablePageContext = createContext()

export const ArticulosTablePageProvider = ({ children }) => {
  const [inputValue, setInputValue] = useState('')
  const [searchedValue, setSearchedValue] = useState('')
  const [sort, setSort] = useState('')
  const [filterByActive, setFilterByActive] = useState('enabled')
  const [filterByActiveActividades, setFilterByActiveActividades] =
    useState('enabled')

  const handleOnChange = e => {
    setInputValue(e.target.value)
  }

  const handleOnSubmit = e => {
    e.preventDefault()
    setSearchedValue(inputValue)
  }

  const resetInfo = () => {
    setInputValue('')
    setSearchedValue('')
    setFilterByActive('all')
  }

  const value = {
    inputValue,
    searchedValue,
    handleOnChange,
    handleOnSubmit,
    resetInfo,
    sort,
    setSort,
    filterByActive,
    setFilterByActive,
    filterByActiveActividades,
    setFilterByActiveActividades,
  }
  return (
    <ArticulosTablePageContext.Provider value={value}>
      {children}
    </ArticulosTablePageContext.Provider>
  )
}

export const useArticulosTablePage = () => {
  const context = useContext(ArticulosTablePageContext)
  if (!context) {
    throw new Error(
      'useArticulosTablePage must be used within a ArticulosTablePageProvider'
    )
  }
  return context
}
